<h5>{{ anfrageTitel }}</h5>
<div class="app-chat-wrapper">
    <ng-container *ngComponentOutlet="chatComponent, inputs: {
        anfrageId: anfrageId,
        scope: scope
    }"></ng-container>
</div>